import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppContext } from '../app.context';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) : Observable<HttpEvent<unknown>> {

    // constructor(private router: Router, private appContext: AppContext) { }

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let appContext = inject(AppContext);
        let router = inject(Router);
        var r = req.clone({
            setHeaders: { 'Authorization': 'Bearer ' + appContext.bearer }
        });
        return next(r).pipe(tap(
            () => { },
            (e: any) => {
                if (e instanceof HttpErrorResponse && e.status === 401) {
                    appContext.logOut();
                    router.navigate(['']);
                }
            }));
    //}
}